import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KATEX_FORMAT } from '@app/app.constants';
import { Answer, IExercise } from '@app/definitions/interfaces';

@Component({
    selector: 'app-pupil-task-exercise',
    templateUrl: './pupil-task-exercise.component.html',
    styleUrls: ['./pupil-task-exercise.component.scss']
})
export class PupilTaskExerciseComponent implements OnInit {
    @Input() exercise: any;
    @Input() selectedExerciseIndex: number;
    @Input() studentId: number;
    @Input() cardId: number;
    @Input() questionAnswers: Answer[] = [];
    @Input() isFinishCard: boolean = false;

    @Output() answered = new EventEmitter();
    @Output() exerciseCompleted = new EventEmitter();
    @Output() exerciseCorrect = new EventEmitter();

    errorMessage: string = null;
    buttons: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    taskAnswersString: string[] = [];
    answeredQuestionCount: number = 0;
    correctQuestionCount: number = 0;

    ngOnInit() {
        console.log(this.exercise);
    }

    isQuestionCorrect(data) {
        this.answeredQuestionCount++;
        if (data) {
            this.correctQuestionCount++;
        }
        if (this.answeredQuestionCount === this.exercise.questions.length) {
            this.exerciseCompleted.emit(true);
            this.answeredQuestionCount = 0;
            if (this.correctQuestionCount === this.exercise.questions.length) {
                this.exerciseCorrect.emit(true);
            } else {
                this.exerciseCorrect.emit(false);
            }
        }
    }

    getQuestionAnswer(question) {
        if (this.questionAnswers.length !== 0) {
            for (const answer of this.questionAnswers) {
                if (question.id === answer.question) {
                    return answer;
                }
            }
        }
        return '';
    }

    emitAnswer(data) {
        this.answered.emit(data);
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }
}
